import { apiClient } from './apiClient';
import { PERMISSION_ENDPOINTS } from '../constants/apiEndpoints';
import { ISidebarSection } from '../config/sidebarMenu';
import {
	IPermissionItem,
	IPermissionsResponse,
} from '../type/permission-type';

const readSidebarSections = (res: IPermissionsResponse | IPermissionItem[]): ISidebarSection[] => {
	if (!res || Array.isArray(res)) return [];
	const raw = res.sidebar_sections;
	if (!Array.isArray(raw)) return [];
	return raw.filter(
		(section) =>
			section &&
			typeof section.key === 'string' &&
			typeof section.label === 'string' &&
			Array.isArray(section.permission_keys),
	);
};

export const permissionService = {
	// GET ALL SYSTEM PERMISSIONS (WITH NESTED CHILDREN & ACCESS OBJECTS)
	async getAllPermissions(): Promise<{
		permissions: IPermissionItem[];
		sidebarSections: ISidebarSection[];
	}> {
		try {
			const res = await apiClient<IPermissionsResponse>(PERMISSION_ENDPOINTS.GET_ALL, {
				method: PERMISSION_ENDPOINTS.GET_ALL.method,
				requiresAuth: true,
			});
			const permissions = Array.isArray(res?.data) ? res.data : [];
			return { permissions, sidebarSections: readSidebarSections(res) };
		} catch (error) {
			console.error('Failed to fetch permissions:', error);
			return { permissions: [], sidebarSections: [] };
		}
	},
};

export default permissionService;
